<template>
    <v-touch @swiperight="swiperright" class="sales-wrapper">
        <div class="supplyVolume">
            <section>
                <header>
                    <div class="headerContent">
                        <div class="head">
                            <h3>合同编号：{{ contractInfo.contract_number }}</h3>
                            <p>{{ contractInfo.engineering_name }}</p>
                            <p>{{ contractInfo.client_name }}</p>
                        </div>
                        <van-divider></van-divider>
                        <div class="progress-wrapper">
                            <div class="progress-content">
                                <p :style="{width: `${progressWidth}%`}"></p>
                                <span v-if="progressNumber <= 0" :style="{left: `calc(${progressWidth}% - 10px)`}">{{ progressNumber }}%</span>
                                <span v-else :style="{left: `calc(${progressWidth}% - 22px)`}">{{ progressNumber }}%</span>
                            </div>
                        </div>
                        <div class="sort">
                            <van-swipe
                                class="my-swipe"
                                :autoplay="8000"
                                indicator-color="#E40002"
                                :loop="true"
                            >
                                <van-swipe-item>
                                    <div class="row">
                                        <div class="item item1">
                                            <div class="text">
                                                <span>销售方量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.xsfl }}方
                                            </div>
                                        </div>
                                        <div class="item item2">
                                            <div class="text">
                                                <span>结算方量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.jsfl }}方
                                            </div>
                                        </div>
                                        <div class="item item3">
                                            <div class="text">
                                                <span>签收方量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.qsfl }}方
                                            </div>
                                        </div>
                                    </div>
                                </van-swipe-item>
                                <van-swipe-item>
                                    <div class="row">
                                        <div class="item item1">
                                            <div class="text">
                                                <span>发货方量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.fhfl }}方
                                            </div>
                                        </div>
                                        <div class="item item2">
                                            <div class="text">
                                                <span>生产方量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.scfl }}方
                                            </div>
                                        </div>
                                        <div class="item item3">
                                            <div class="text">
                                                <span>调度派单量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.ddpdl }}方
                                            </div>
                                        </div>
                                    </div>
                                </van-swipe-item>
                                <van-swipe-item>
                                    <div class="row">
                                        <div class="item item2">
                                            <div class="text">
                                                <span>出场过磅量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.ccgbl }}方
                                            </div>
                                        </div>
                                        <div class="item item3">
                                            <div class="text">
                                                <span>调度完成方量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.ddwcfl }}方
                                            </div>
                                        </div>
                                        <div class="item item3">
                                            <div class="text">
                                                <span>剩退灰量</span>
                                            </div>
                                            <div class="volume">
                                                {{ deliveryStatistics.ttfl }}方
                                            </div>
                                        </div>
                                    </div>
                                </van-swipe-item>
                            </van-swipe>
                        </div>
                    </div>
                </header>
                <div class="list-wrapper">
                    <div class="block">
                        <div class="search-conditions">
                            <span class="time-con" @click="showCalendar(1, startTime)">
                                <span>{{ startTime }}</span>
                            </span>
                            <span class="org" @click="showCalendar(2, endTime)">
                                <span class="org-name">{{ endTime }}</span>
                            </span>
                        </div>
                    </div>
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <ul>
                            <li v-for="(item,index) in listData" :key="index" class="item">
                                <h6 class="item-time">
                                    {{ item.creation_date }}
                                </h6>
                                <div class="item-content">
                                    <div class="row-tit">
                                        <span class="iconfont icondanjubianhao"></span>
                                        <span class="info">任务单号：{{ item.task_number }}</span>
                                    </div>
                                    <div class="row-item">
                                        <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                        <span class="info">供应场站：{{ item.station_name }}</span>
                                    </div>
                                    <div class="row-item">
                                        <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                        <span class="info">砼品种：{{ item.concrete_varieties }}</span>
                                    </div>
                                    <div class="row-item">
                                        <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                        <span class="info">施工部位：{{ item.place_detail }}</span>
                                    </div>
                                    <div class="row-item group-item">
                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                        <span class="info">
                                            <div>
                                                <span>签收方量：{{ item.adjusted_sign_volume }}方</span>
                                            </div>
                                            <div class="info-item" v-if="$store.state.versionMark == 2">
                                                <span>砼单价：{{ item.adjusted_concrete_price }}元/方 </span>
                                                <span> 砼金额：{{ item.adjusted_concrete_amount_money }}元</span>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="row-item group-item">
                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                        <span class="info">
                                            <div>
                                                <span>泵送方量：{{ item.adjusted_pump_volume }}方</span>
                                            </div>
                                            <div class="info-item" v-if="$store.state.versionMark == 2">
                                                <span>泵送金额:{{ item.adjusted_pump_money }}元/方</span>
                                                <span>运费:{{ item.adjusted_freight }}元</span>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="row-item group-item" v-if="$store.state.versionMark == 2">
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span class="info">
                                            <div>
                                                <span>补方数：{{ item.replenish_quantity }}</span>
                                            </div>
                                            <div class="info-item">
                                                <span>补方金额：{{ item.replenish_money }}元</span>
                                                <span>其他金额：{{ item.other_amounts }}元</span>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="row-item" v-if="$store.state.versionMark == 2">
                                        <img src="@/assets/images/icons/icon_18.png" alt="">
                                        <span class="info">应收金额：{{ item.receivable_amount }}元</span>
                                    </div>
                                    <div class="row-item" v-if="$store.state.versionMark == 2">
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span class="info">累计金额：{{ item.accumulated_amount }}元</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </div>
            </section>
            <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="选择年月日"
                    @confirm="confirmDate"
                    @cancel="cancelDate"
                ></van-datetime-picker>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
import util from '@/utils/util';
export default {
    // 供应方量
    name: 'supply-volume',
    components: {},
    props: {
        contractNumber: {
            type: String,
        },
        contractInfo: {
            type: Object,
        },
    },
    data() {
        return {
            // 供应方量list
            listData: [],
            // 上一个页面带过来的合同信息
            detail: {},
            suppleVolume: {
                projected_capacity: 0, // 预计方量
                volume: 0, // 发货方量
                sign_volume: 0, // 签收方量
                supply_time_first: '', // 首次供应时间
            },
            progressWidth: 0,
            progressNumber: 0,
            // 统计块
            deliveryStatistics: {},
            // 时间筛选
            showCalendarPop: false,
            startTime: '',
            endTime: '',
            currentDate: new Date(),
            pickTimeType: 1,
            // 列表
            pageindex: 0,
            loading: false,
            finished: false,
        };
    },
    computed: {

    },
    filters: {
        getTime: value => {
            let str = '';
            if (value) {
                str = value.substr(0, 10);
            }
            return str;
        },
    },
    watch: {
        // suppleVolume() {
        //     this.progressNumberChange();
        //     this.progressWidthChange();
        // },
    },
    created() {},
    mounted() {
        this.init();
    },
    destroyed() {},
    methods: {
        init() {
            const endTime = util.currentTimeFormat('yyyy-MM-dd');
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const startTime = year + '-' + month + '-01';
            this.startTime = startTime;
            this.endTime = endTime;
            this.handleDeliveryStatistics();
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 展示日历
        showCalendar(type, time) {
            this.pickTimeType = type;
            const timeArr = time.split('-');
            this.currentDate = new Date(timeArr[0], timeArr[1] - 1, timeArr[2]);
            this.showCalendarPop = true;
        },
        // 分页拉取
        onLoad() {
            // this.listData = [];
            this.pageindex += 1;
            this.handleDailytaskList();
        },
        // 处理任务信息
        async handleDailytaskList() {
            const res = await this.getDailytaskList();
            this.loading = false;
            if (res.list.total) {
                this.listData = this.listData.concat(res.list.rows);
                if (this.listData.length >= res.list.total) {
                    this.finished = true;
                }
            } else {
                this.total = 0;
                this.finished = true;
            }
        },
        // 处理生产发货统计数据
        async handleDeliveryStatistics() {
            const res = await this.getDeliveryStatistics();
            if (res) {
                this.deliveryStatistics = res;
                if (this.deliveryStatistics.jsfl && this.deliveryStatistics.xsfl) {
                    this.progressWidth = Number((this.deliveryStatistics.jsfl / this.deliveryStatistics.xsfl * 100).toFixed(2));
                    this.progressNumber = Number((this.deliveryStatistics.jsfl / this.deliveryStatistics.xsfl * 100).toFixed(2));
                    if (this.progressWidth > 100) {
                        this.progressWidth = 100;
                    }
                    if (this.progressWidth < 0) {
                        this.progressWidth = 0;
                    }
                }
            }
        },
        confirmDate(value) {
            this.showCalendarPop = false;
            if (this.pickTimeType === 1) {
                this.startTime = this.formatDate(value);
            } else {
                this.endTime = this.formatDate(value);
            }
            this.handleDeliveryStatistics();
            this.finished = false;
            this.listData = [];
            this.pageindex = 1;
            this.handleDailytaskList();
        },
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = date.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        // 获取生产发货统计数据
        getDeliveryStatistics() {
            const path = '/interfaceApi/sale/contract_archives/get_delivery_statistics/' + this.contractNumber;
            return this.$axios.$get(path, { defEx: true });
        },
        // 分页拉取任务信息
        getDailytaskList() {
            const path = '/interfaceApi/sale/contract_archives/get_accounts_dailytask_list?begin_time=' + this.startTime
            + '&end_time=' + this.endTime + '&contract_number=' + this.contractNumber
            + '&pageindex=' + this.pageindex + '&pagesize=2';
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
@import '~@/assets/styles/mixins.styl';
.sales-wrapper
    height 100%
    background #f0f0f0
    .supplyVolume
        height 100%
        section
            height 100%
            background #F0F0F0
            overflow hidden
            header
                background #2b5dab
                padding 15rpx
                .headerContent
                    height 100%
                    background 100%
                    background #fff
                    border-radius 4rpx
                    .head
                        padding 14rpx
                        h3
                            font-size 16rpx
                            color #333333
                            margin-bottom 10rpx
                        p
                            font-size 14rpx
                            color #979EA7
                    .van-divider
                        margin 0
                    .progress-wrapper
                        padding 25rpx 15rpx 10rpx 15rpx
                        .progress-content
                            height 18rpx
                            background rgba(254,247,235,1)
                            border 2px solid rgba(250,132,54,1)
                            border-radius 10px
                            position relative
                            padding 2rpx
                            p
                                height 10rpx
                                background #3495FB
                                border-radius 10rpx
                                transition all 2s
                            span
                                background #3495FB
                                height 20rpx
                                color #ffffff
                                position absolute
                                top -22rpx
                                font-size 12rpx
                                border-radius 4rpx
                                text-align center
                                line-height 20rpx
                                &::after
                                    content ""
                                    width 0
                                    height 0
                                    border 4rpx solid
                                    border-color #3495FB transparent  transparent  transparent
                                    position absolute
                                    left 50%
                                    margin-left -3rpx
                                    bottom -8rpx


                    .sort
                        overflow hidden
                        padding 0 10rpx 6rpx 10rpx
                        .van-swipe__indicators
                            bottom 0
                            .van-swipe__indicator
                                width 15rpx
                                height 3rpx
                                background #999
                                border-radius 2rpx

                        .row
                            .item
                                margin 10rpx 4rpx
                                float left
                                width calc(33.33% - 8rpx)
                                .text
                                    font-size 12rpx
                                    color #979EA7
                                    text-align center
                                    .iconfont
                                        font-size 12rpx
                                        margin-right 5rpx
                                .volume
                                    height 22rpx
                                    line-height 22rpx
                                    margin-top 3rpx
                                    text-align center
                                    font-size 16rpx
                                    text-ellipsis()
                                    padding 0 5rpx
                                    width 100%
                                &.item1
                                    .volume
                                        background rgba(250, 132, 54, 0.06)
                                        color #fa8436
                                &.item2
                                    .volume
                                        background rgba(85, 136, 241, 0.06)
                                        color #5588F1
                                &.item3
                                    .volume
                                        background rgba(33, 189, 204, 0.06)
                                        color #21BDCC
                                &.item4
                                    .volume
                                        background rgba(134, 107, 238, 0.06)
                                        color #866BEE
                                &.item5
                                    .volume
                                        background rgba(248, 165, 1, 0.06)
                                        color #F8A501
                                &.item6
                                    .volume
                                        background rgba(33, 189, 204, 0.06)
                                        color #21BDCC
            .list-wrapper
                height calc(100% - 250rpx)
                .block
                    padding 10rpx
                    .search-conditions
                        font-size 16rpx
                        height 45rpx
                        box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
                        border-radius 4rpx
                        padding 10rpx 20rpx
                        display flex
                        justify-content space-around
                        line-height 25rpx
                        background #fff
                        .time-con
                            position relative
                            flex 1
                            text-align center
                            &:after
                                content ''
                                position absolute
                                right 10rpx
                                height 15rpx
                                border-right 1px solid #D7D7D7
                                margin-top 5rpx
                        .iconfont
                            font-size 14rpx
                            color #979EA7
                            margin-left 5rpx
                        .org
                            flex 1
                            text-align center
                .no_data
                    padding-top 10rpx
                    text-align center
                .van-list
                    height: calc(100% - 68rpx)
                    overflow: scroll;
                    -webkit-overflow-scrolling: touch;
                ul
                    padding 15rpx
                    .item
                        .item-time
                            font-size 12rpx
                            color #979EA7
                            position relative
                            height 20rpx
                            line-height 20rpx
                            padding-left 20rpx
                            &::after
                                content ""
                                width 10rpx
                                height 10rpx
                                border-radius 50%
                                background rgba(230,0,0,1);
                                opacity 0.2;
                                position absolute
                                top 5rpx
                                left 0
                            &::before
                                content ""
                                width 5rpx
                                height 5rpx
                                border-radius 50%
                                background rgba(230,0,0,1);
                                position absolute
                                top 7.5rpx
                                left 2.5rpx
                        .item-content
                            margin-bottom 15rpx
                            background #ffffff
                            border-radius 4rpx
                            overflow hidden
                            padding 15rpx
                            p
                                width 50%
                                float left
                                line-height 30rpx
                                font-size 14rpx
                                color #666666
                                img
                                    width 14rpx
                                    margin-right 10rpx
                                    vertical-align middle
                            .row-item
                                // height 21rpx
                                margin-top 6rpx
                                position relative
                                // line-height 21rpx
                                img
                                    width 14rpx
                                    vertical-align middle
                                    margin-right 5rpx
                                .info
                                    font-size 14rpx
                                    color #666666
                                    vertical-align middle
                            .row-tit
                                font-size 16rpx
                                .iconfont
                                    color #3394FA
                                    margin-right 5rpx
                            .group-item
                                position relative
                                height 44rpx
                                img
                                    position absolute
                                    left 0
                                    top 3rpx
                                .info
                                    position absolute
                                    left 20rpx
                                    width calc(100% - 20rpx)
                                    .info-item
                                        margin-top 3rpx
                                        display flex
                                        >span
                                            flex 1

</style>